export default __webpack_public_path__ + "static/media/plus.226571c8.svg";